import {combineReducers} from "redux"
import {registriesReducer} from "./reducers/registriesReducer"
import {registrySearchableFieldsReducer} from "./reducers/registrySearchableFieldsReducer"
import {appReducer} from "./reducers/appReducer"

export const rootReducer = combineReducers({
    registries: registriesReducer,
    registrySearchableFields: registrySearchableFieldsReducer,
    app: appReducer
})